<div class="row">
  <div class="l-pt-7 l-pb-7">
    <div class="cds-h2-demibold">{{ 'common.error2' | lang }}</div>
    <div class="cds-h2-demibold l-pt-3">This path is no longer in use.</div>
  </div>
</div>
